// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // "pathname" cambia cada vez que la URL es diferente.
    // Este efecto se ejecuta y resetea el scroll.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Este componente no renderiza nada.
}

export default ScrollToTop;